export const SET_COMPLAINTS = 'SET_COMPLAINTS'
export const SET_COMPLAINT = 'SET_COMPLAINT'
export const CLEAR_COMPLAINTS = 'CLEAR_COMPLAINTS'
export const GET_QUESTION_COMPLAINTS = 'GET_QUESTION_COMPLAINTS'
